"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class MessageLinksProvider extends DataProvider_1.default {
    get fragments() {
        return {
            MessageLink: () => `
        ... on MessageLink {
          id
          messageId
          subject {
            subjectId
            subjectType
          }
        }
      `,
        };
    }
    find({ messageIds }) {
        return this.query("messageLinksFind", { messageIds }, this.getFragment("MessageLink"));
    }
    create({ data }) {
        return this.mutate("messageLinksCreate", { data }, this.getFragment("MessageLink"));
    }
}
exports.MessageLinksProvider = MessageLinksProvider;
//# sourceMappingURL=MessageLinksProvider.js.map